import React from 'react';
import './Ok.css';
import '../../styles/colors.css';

const Ok = props => {
    const clickHandler = props.clickHandler;

    return (
        <button className='Ok' onClick={clickHandler}>OK</button>
    );
}

export default Ok;